export default __webpack_public_path__ + "static/media/checkWhite.c446ed36.svg";